var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('st-page',{attrs:{"showHeader":false}},[_c('application-documents-list-filter',{attrs:{"documentType":_vm.documentType}},[_c('application-documents-list-table',{attrs:{"documentType":_vm.documentType}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }